import CircledButton from '@/library/components/buttons/CircledButton';
import styled from '@emotion/styled';
import { FC, useCallback, useState } from 'react';
import { Attachment, Size } from '@/library/types/files';
import DangerousActionModal from '@/library/components/modals/DangerousActionModal';
import circleRemove from '@/library/assets/svg/actions/circle-remove.svg';

const iconSize: {
  [key in 'lg' | 'sm' | 'xs' | 'full']: number;
} = {
  full: 18,
  lg: 18,
  sm: 12,
  xs: 10
};

const svgSize: {
  [key in 'lg' | 'sm' | 'xs' | 'full']: number;
} = {
  full: 8,
  lg: 8,
  sm: 4,
  xs: 4
};

type FileRemoveButtonProps = {
  size: Size;
  file?: Attachment;
  onClick: () => void;
};

const FileRemoveButton: FC<FileRemoveButtonProps> = ({ size, onClick, file }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const closeModal = useCallback(() => setIsModalOpen(false), []);
  const openModal = useCallback(() => setIsModalOpen(true), []);

  return (
    <Container className="file-remove-icon" size={size} data-testid="files-remove-button">
      <CircledButton
        type="remove"
        svgStyle={{ width: svgSize[size], height: svgSize[size] }}
        size={iconSize[size]}
        onClick={openModal}
      />

      <DangerousActionModal
        onAccept={async () => {
          await onClick();
          closeModal();
        }}
        icon={circleRemove}
        svgColor="white"
        acceptButtonBackground="primary"
        onCancel={closeModal}
        isOpen={isModalOpen}
        header={'Remove File'}
        acceptButtonText="REMOVE"
      >
        Are you sure you want to remove the file{' '}
        {file ? <span className="fw-bold">&quot;{file.filename}&quot;</span> : null} ?
      </DangerousActionModal>
    </Container>
  );
};

const Container = styled.div`
  position: absolute;
  right: ${({ size }: { size: Size }) => `-${iconSize[size] / 2 - 2}px`};
  top: -2px;
  z-index: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: 0;
`;

export default FileRemoveButton;
